module.exports = __webpack_public_path__ + "static/media/smarterbuilding_logo_web.1fbaaa77.png";